import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MetroButtonComponent } from '../metro-button/metro-button.component';

@Component({
  selector: 'app-metro-modal',
  templateUrl: './metro-modal.component.html',
  standalone: false,
})
export class MetroModalComponent {
  @Input() isOpen: boolean = false;
  @Input() title: string = '';
  @Input() closeOnConfirm: boolean = true;
  @Input() showCloseIcon = true;
  @Input() confirmText = '::Save'; // Key for localization
  @Input() showFooter = true;
  @Input() showHeader = true;

  get isAndroid() {
    return /Android/i.test(window.navigator.userAgent);
  }


  @Output() close = new EventEmitter<void>();

  @Output() confirm = new EventEmitter<void>();
  @Output() cancelAction = new EventEmitter<void>();


  closeModal() {
    this.cancelAction.emit();
    this.close.emit();
  }

  onConfirm() {
    this.confirm.emit();
    if (this.closeOnConfirm) {
      this.close.emit();
    }
  }
}
